import { render, staticRenderFns } from "./backoffice-notificacoes.vue?vue&type=template&id=e5ddae4e"
import script from "./backoffice-notificacoes.vue?vue&type=script&lang=ts"
export * from "./backoffice-notificacoes.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-notificacoes.vue?vue&type=style&index=0&id=e5ddae4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports